// Copyright 2025. WebPros International GmbH. All rights reserved.

import React, { useEffect } from 'react';
import ResilienceStatusTable from 'admin/disasterRecovery/components/ResilienceStatusTable';
import {
    Translate,
    Button,
    Icon,
} from '@plesk/ui-library';
import { Header } from 'admin/common/components/PageHeader/Styles';
import { Title } from 'admin/update/containers/Styles';
import moment from 'moment';
import { readiness } from 'common/api/resources/DisasterRecovery';
import { IResilienceStatusTableProps } from 'common/api/resources/DisasterRecovery/model';


export const ResilienceStatus: React.FC = () => {
    const [healthCheck, setHealthCheck] = React.useState<IResilienceStatusTableProps | null>(null);
    const [lastUpdatedTime, setLastUpdatedTime] = React.useState<string | null>(null);


    const fetchCachedReadinessStatus = async () => {
        try {
            const response = await readiness.getCachedReadinessStatus();
            const data: IResilienceStatusTableProps = response.data;

            const tableData: IResilienceStatusTableProps = {
                compute_resources: data.compute_resources ?? [],
            };

            setHealthCheck(tableData);

            if (data.lastUpdatedTime) {
                setLastUpdatedTime(moment(data.lastUpdatedTime).format('HH:mm:ss'));
            }
        } catch (e) {
            throw e;
        }
    };

    const handleRefresh = async () => {
        await readiness.refreshRecoveryReadinessStatus();
        await fetchCachedReadinessStatus();
    };

    useEffect(() => {
        fetchCachedReadinessStatus();
    }, []);

    return (
        <>
            <Header>
                <Title>
                    <Translate content="computeResource.resilienceStatus.title" />
                </Title>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                    <span style={{ marginRight: '10px' }}>
                        <Translate
                            content="computeResource.resilienceStatus.lastStatusUpdate"
                            params={{ time: lastUpdatedTime || 'N/A' }}
                        />
                    </span>
                    <Button
                        icon={<Icon name="refresh" size={24} />}
                        ghost={true}
                        onClick={handleRefresh}
                        tooltip={<Translate content="computeResource.resilienceStatus.updateStatus" />}
                    >
                        Refresh
                    </Button>
                </div>
            </Header>
            {healthCheck && (
                <ResilienceStatusTable
                    compute_resources={healthCheck.compute_resources}
                />
            )}
        </>
    );
};

export default ResilienceStatus;